import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class BundleLoaderService {
  constructor() {}
  loadBundle(src: string, onload?, onErr?) {
    const isLoaded = this.isBundleLoaded(src);
    if (!isLoaded) {
      // create the script tag for the for the web-component
      const node = document.createElement('script');
      node.src = src;
      node.type = 'text/javascript';
      node.onload = onload;
      node.onerror = onErr;
      // adds the script tag to the head element
      document.getElementsByTagName('head')[0].appendChild(node);
    } else if (onload) {
      onload();
    }
  }

  loadWebComponent(
    component: string,
    src: string,
    containerId: string,
    data?: any
  ) {
    this.loadBundle(src, () => {
      this.injectWebComponent(component, containerId, data);
    });
  }

  injectWebComponent(component: string, containerId: string, data?: any) {
    const el = document.createElement(component);

    if (data) {
      Object.keys(data).forEach(key => {
        el.setAttribute(key, data[key]);
      });
    }

    const container = document.getElementById(containerId);
    if (container.children.length > 0) {
      container.removeChild(container.children[0]);
    }
    container.appendChild(el);
  }

  public isBundleLoaded(src: string): boolean {
    const scripts = document.getElementsByTagName('script');

    return (
      Array.from(scripts).find(script => script.getAttribute('src') === src) !==
      undefined
    );
  }
}
